<template>
  <div style="display: inline-block;">
    <span @click="printOn()">【打印】</span>
  </div>
</template>
<script>
export default {
  name: 'printOn',
  methods: {
    printOn(){
          document.getElementById('print').style.zoom=0.5;
          window.print();
          document.getElementById('print').style.zoom=1;
        },
  }
}
</script>
<style scoped>
@media print{
  body {
      width: auto !important;
      height: auto !important;
  }
}
</style>